import { Box, Button, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';
import { bodyWidth } from '../../utils/Style';
import { useThemeColor } from '../../hooks/useThemeColor';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';
import { useLocalizedText } from '../../hooks/useLocalizedText';

export const OrderSuccessPage = () => {
  const t = useLocalizedText();

  const navigate = useNavigate();

  const { primary, secondary } = useThemeColor();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <GenericHelmet title={t('order_result.success.title')} />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: bodyWidth,
          alignItems: 'center',
          py: 3,
          px: 1.5,
          boxSizing: 'border-box',
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 120, color: primary }} />

        <Typography sx={{ fontSize: '40px', fontWeight: 600 }}>
          {t('order_result.success.thanks_for_shopping')}
        </Typography>

        <Typography sx={{ fontSize: '24px' }}>
          {t('order_result.success.order_received')}
        </Typography>

        <Button
          onClick={() => navigate('/')}
          variant='contained'
          sx={{
            textTransform: 'none',
            backgroundColor: primary,
            color: secondary,
            mt: 1.5,
          }}
        >
          {t('order_result.success.continue_shopping')}
        </Button>
      </Box>
    </Box>
  );
};
